import image from "../../img/stalker.png";
import React from "react";
import { All, Button, LP, PP } from "./Style";
function Stalker2() {
  return (
    <All>
      <LP zrodlo={image}></LP>
      <PP>
        <h1>Reklama S.T.A.L.K.E.R. 2 (nieoficjalna)</h1>
        <p>
          Projekt reklamy gry komputerowej Stalker 2, zrobiony w CSS. Reklama
          nieoficjalna, projekt artystyczny.
        </p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://szotauniverse.pl/reklama/index.html"
        >
          <Button>Zobacz</Button>
        </a>
      </PP>
    </All>
  );
}

export default Stalker2;
